import * as React from "react";
import { getS3Variant } from "archive/logic/s3CompatibleProviders";
import S3CredentialsFieldGroup, {
  validateS3CredentialsFields
} from "data-tiering/repository-management/S3CredentialsFieldGroup";
import { S3_AUTH_MODE } from "data-tiering/repository-management/types";
import S3CredentialsFormFields, {
  validateS3CredentialsForm
} from "data-tiering/warm-tier-repositories/S3CredentialsFormFields";
const S3CreateFields = ({ type }) => /* @__PURE__ */ React.createElement(S3CredentialsFieldGroup, { variant: getS3Variant(type) });
const S3EditFields = ({ record }) => {
  var _a;
  return /* @__PURE__ */ React.createElement(S3CredentialsFormFields, { secretIsSet: !!((_a = record == null ? void 0 : record.aws_secret_access_key) == null ? void 0 : _a.is_set) });
};
const initialEditValues = (stored) => {
  var _a, _b, _c, _d, _e, _f;
  const record = stored;
  return record ? {
    auth_mode: record.auth_mode,
    aws_access_key_id: (_a = record.aws_access_key_id) != null ? _a : void 0,
    aws_secret_access_key: ((_b = record.aws_secret_access_key) == null ? void 0 : _b.is_set) ? { keep_value: true } : void 0,
    aws_region: (_c = record.aws_region) != null ? _c : void 0,
    endpoint_uri: (_d = record.endpoint_uri) != null ? _d : void 0,
    aws_assume_role_arn: (_e = record.aws_assume_role_arn) != null ? _e : void 0,
    aws_external_id: (_f = record.aws_external_id) != null ? _f : void 0
  } : { auth_mode: "key_secret" };
};
const toUpdatePayload = (values) => {
  var _a, _b, _c, _d;
  return {
    auth_mode: values.auth_mode,
    aws_access_key_id: values.auth_mode === "key_secret" && values.aws_access_key_id || null,
    aws_secret_access_key: values.auth_mode === "key_secret" ? values.aws_secret_access_key : void 0,
    aws_region: (_a = values.aws_region) != null ? _a : null,
    endpoint_uri: (_b = values.endpoint_uri) != null ? _b : null,
    aws_assume_role_arn: (_c = values.aws_assume_role_arn) != null ? _c : null,
    aws_external_id: (_d = values.aws_external_id) != null ? _d : null
  };
};
const s3Definition = {
  create: {
    initialValues: () => ({
      auth_mode: S3_AUTH_MODE.AUTOMATIC,
      aws_access_key_id: void 0,
      aws_secret_access_key: void 0,
      aws_region: void 0,
      endpoint_uri: void 0,
      aws_assume_role_arn: void 0,
      aws_external_id: void 0
    }),
    validate: (credentials) => validateS3CredentialsFields(credentials),
    Fields: S3CreateFields
  },
  edit: {
    initialValues: initialEditValues,
    validate: (values) => validateS3CredentialsForm(values),
    toPayload: (values) => toUpdatePayload(values),
    Fields: S3EditFields
  }
};
export default s3Definition;
